import architectureDiagramHtml from './pages/architecture-diagram';
import architectureDetailsHtml from './pages/architecture-details';
import silEventbusHandlerHtml from './pages/sil-eventbus-handler';
import natsStreamAggregatorHtml from './pages/nats-stream-aggregator';
import vtslCallRecorderApiHtml from './pages/vtsl_call_recorder_api';
import vtslRecordingEventbusHandlerHtml from './pages/vtsl-recording-eventbus-handler';
import siprecApiGatewayHtml from './pages/siprec-api-gateway';
import vtslSilhouteHtml from './pages/vtsl_silhoute';
import silhouteEventParserHtml from './pages/silhoute_event_parser';

export const DOCS = [
    {
        id: 'architecture-diagram',
        html: architectureDiagramHtml,
        title: 'Architecture Diagrams',
        category: 'Platform',
        summary:
            'How the seven VTSL services fit together — PBX and FreeSWITCH at the edge, event pipelines in the middle, and portal-facing APIs on top.',
    },
    {
        id: 'architecture-details',
        html: architectureDetailsHtml,
        title: 'Service Reference',
        category: 'Platform',
        summary:
            'Written walk-through of each service: what it does, what it talks to, the contracts they meet on, and where the seams are.',
    },
    {
        id: 'sil-eventbus-handler',
        html: silEventbusHandlerHtml,
        title: 'sil-eventbus-handler',
        category: 'Service',
        summary:
            'Front door for everything the phone system tells the platform. Listens to the Silhouette PBX event feed and republishes a clean call summary.',
    },
    {
        id: 'nats-stream-aggregator',
        html: natsStreamAggregatorHtml,
        title: 'nats-stream-aggregator',
        category: 'Service',
        summary:
            'One-job relay that copies call events from each phone-system node onto a single shared bus so other services listen in one place.',
    },
    {
        id: 'vtsl_call_recorder_api',
        html: vtslCallRecorderApiHtml,
        title: 'vtsl_call_recorder_api',
        category: 'Service',
        summary:
            'Recording engine controller. Listens for call-answered events, decides whether recording is allowed, and drives FreeSWITCH start/stop.',
    },
    {
        id: 'vtsl-recording-eventbus-handler',
        html: vtslRecordingEventbusHandlerHtml,
        title: 'vtsl-recording-eventbus-handler',
        category: 'Service',
        summary:
            'Three related services that map recordings to calls and enforce which customer is allowed to see them.',
    },
    {
        id: 'siprec-api-gateway',
        html: siprecApiGatewayHtml,
        title: 'siprec-api-gateway',
        category: 'Service',
        summary:
            'Read-and-control facade for customer portals — recordings, transcripts, live-call state, and recording controls.',
    },
    {
        id: 'vtsl_silhoute',
        html: vtslSilhouteHtml,
        title: 'vtsl_silhoute',
        category: 'Service',
        summary:
            'Customer-facing configuration API for users, handsets, numbers, groups, routing, opening hours, and voicemail.',
    },
    {
        id: 'silhoute_event_parser',
        html: silhouteEventParserHtml,
        title: 'silhoute_event_parser',
        category: 'Service',
        summary:
            'Live dashboard feed. Listens for queue and group activity and pushes updates to browsers over WebSocket.',
    },
];

export const DOC_IDS = DOCS.map((doc) => doc.id);

export const getDocById = (id) => DOCS.find((doc) => doc.id === id);
